import React, { Component } from 'react';
import { translate } from 'react-i18next';

class GraciasSurvey extends Component {

  render() {
    let encuesta = this.props.encuesta;  
    const { t } = this.props;
    
      return(
          <div id="politicasFirmadas" className="survey-page-body hidden" >
            <div className="alert alert-info" >
             Texto de agradecimiento, Politicas Firmadas
            </div>
          </div>
          );
  }
}

export default translate('common')(GraciasSurvey);



// WEBPACK FOOTER //
// ./src/guest/BrokerPoliticas/PoliticasFirmadasGracias.js